const a = require('he');

export const he:any = a;
